import React from 'react';
import { connect } from 'react-redux';
import { HashLink } from 'react-router-hash-link';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toDate, fromNow } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import Adresse from '../Adresse';
import AdresseLien from '../AdresseLien';



const swalReact = withReactContent(swal);

const Badge = ({ titre, couleur }) => (
    <h6>
        <span className={`badge badge-pill badge-actualite ${couleur} text-uppercase mr-3`}>{titre}</span>
    </h6>
);


function afficherPopupVote(popup) {
    if (popup) {
        swalReact.fire({
            type: 'info',
            title: popup.titre,
            html: popup.contenu,
            showCancelButton: true,
            confirmButtonColor: '#17A2B8',
            cancelButtonText: 'Ok',
            confirmButtonText: 'Ordre du jour et votes',
        }).then((result) => {
            if (result.value) {
                window.location.href = "/MaCopropriete";
            } 
          });
    }
}
function afficherPopup(popup) {
    if (popup) {
        swalReact.fire({
            type: 'info',
            title: popup.titre,
            html: popup.contenu,
        });
    }
}

function SetNumReunion(NumR) {
    window.location.href = "/MesInformations/MonAG/" + NumR;
}


const LigneActu = ({
    type, dDate, objet, memo, nouveau, lien, popup,
}) => (
    <HashLink to={lien} onClick={() => afficherPopup(popup) }>
        <div className="list-group-item list-group-item-action" title={memo ? memo : ""}>
        {nouveau ? <span style={{ position: "absolute", top: 5, right: 5}} className="badge badge-pill badge-danger">new</span> : ""}
            <div className="media">
                <div className="text-center align-self-center">
                    <Badge {...type} />
                </div>
                <div className="media-body text-truncate">
                    <strong>{objet}</strong>
                    <br />
                    {toDate(dDate, 'LLL')} - {fromNow(dDate)}
                </div>
            </div>
        </div>
    </HashLink>
);

const CardActualite = ({
    LsReunions, LsNews, Docs, Messages, Syn
}) => {
    const liste = [];

    if (LsReunions && LsReunions.length > 0) {
        LsReunions.forEach((reunion) => {

            let d1 = new Date(reunion.VoteFin);
            let dh = new Date();
            let sdh = dh.toDateString();
            let d2 = new Date(sdh);
            let futur =0 
            d1>=d2 ? futur=1 : futur=0
            let nbd=Math.floor((d1-d2)/1000/60/60/24)
            let l1 = ""
            let l2 = ""
            let ico = "RIEN"
            let TextVote=''
    
            if (reunion.EtatReu != 1 && futur==1) {l1="Votes actuellement fermés"}
            if (reunion.EtatReu != 1 && futur==0) {l1=`Votes fermés depuis le ${toDate(reunion.VoteFin, 'DD/MM/YYYY')}`}
            if (reunion.EtatReu == 1) {l1=`Votes ouverts jusqu'au ${toDate(reunion.VoteFin, 'DD/MM/YYYY')}`}
    
            if (reunion.EtatReu != 1 && futur==1 && reunion.EtatVotePro==1) {l2=``}
            if (reunion.EtatReu != 1 && ( reunion.EtatVotePro==2 || reunion.EtatVotePro==3)) {l2=`Vos votes n'ont pas été validés`}
    
            if (reunion.EtatVotePro==4) {l2=`Vous avez validé vos votes`}
            if (reunion.EtatVotePro==5) {l2=`Votre formulaire a été receptionné par le syndic`}
            if (reunion.EtatVotePro==6) {l2=`Vos votes ont été recus et enregistrés par le syndic`}
            if (reunion.EtatReu == 1 && futur==1 && ( reunion.EtatVotePro==2 || reunion.EtatVotePro==3) && nbd==0) {l2=`C'est le dernier jour pour valider vos votes`}
            if (reunion.EtatReu == 1 && futur==1 && ( reunion.EtatVotePro==2 || reunion.EtatVotePro==3) && nbd>0) {l2=`Il vous reste ${nbd+1} jours pour valider vos votes`}
         // if (reunion.EtatReu == 1 && futur==1 && ( reunion.EtatVotePro==2 || reunion.EtatVotePro==3)) {l2=`Il vous reste ${fromNow(VoteFin).replace("dans","")} pour valider vos votes`}
            if (reunion.EtatReu == 1 && ( reunion.EtatVotePro==1 )) {l2=`Vous pouvez commencer à voter`}
            if (reunion.EtatReu != 1 && futur==0 && reunion.EtatVotePro==1) {l2=`Vous n'avez pas voté par formulaire en ligne`}
    
    
            if ((reunion.EtatVotePro==2 || reunion.EtatVotePro==3)) {ico=`ALERTE`}
            if (reunion.EtatVotePro>=4) {ico=`OK`}
           
            if (reunion.EtatReu != 1 && ( reunion.EtatVotePro==1 )) {TextVote=`Ordre du Jour`}
            if (reunion.EtatReu == 1 && ( reunion.EtatVotePro==1 )) {TextVote=`Ordre du Jour et Votes`}
            if ( reunion.EtatVotePro==2 || reunion.EtatVotePro==3 || reunion.EtatVotePro==4 || reunion.EtatVotePro==6) {TextVote=`Ordre du Jour et Votes`}
            if ( reunion.EtatVotePro==5) {TextVote=`Ordre du Jour`} 

            const {
                DateDebut, DateFin, Libelle, Nom, VoteFerme, Type, VoteDebut, VoteFin, EtatReu, NumReunion, EtatVotePro
            } = reunion;
            const heure =
                DateFin === '0001-01-01T00:00:00'
                    ? `à partir de ${toDate(DateDebut, 'HH:mm')}`
                    : `de ${toDate(DateDebut, 'HH:mm')} à ${toDate(DateFin, 'HH:mm')}`;
            const contenu = (
                <div className="text-center">
                    <p>
                        Le {toDate(DateDebut, 'DD/MM/YYYY')} {heure}
                    </p>
                    <b>{Nom}</b>
                    {reunion.Adresse && <Adresse {...reunion.Adresse} className="justify-content-center" />}
                    {/* <AdresseLien {...reunion} className="justify-content-center" /> */}
                    {(Type === "AG" && Syn.VoteFormActifOk) ? ( 
                        <div  className="media-body text-center small">
                            <br/>{l1}<br/>
                            <p className={`${ico=='ALERTE' ? "card acc-valide-erreur" : ""} `}><span style={{fontWeight:"600"}}>
                            {ico=='OK' ? <i className='fa fa-lg fa-check text-success' style={{paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}
                            {ico=='ALERTE' ? <i className='fa fa-exclamation-triangle fa-lg acc-ico-erreur' style={{color:'#DC3545',paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}                    
                            {l2}</span>
                        </p>
                            {TextVote.length>0 ? (
                                <a className="btn btn-outline-primary mt-2" onClick={() => SetNumReunion(NumReunion)} >{TextVote}</a>
                            ) : ( null)} 
                            <span style={{fontWeight:"normal"}}>
                            </span>
                        </div>
                     ) : ("")}
                </div>
            );



            liste.push({
                type: { titre: 'Réunion', couleur: 'badge-reunion' },
                dDate: DateDebut,
                objet: Libelle,
                lien: '',
                popup: { Titre: Libelle, contenu },
                adresse: reunion.Adresse,
                VoteFerme: VoteFerme, 
                VoteDebut: VoteDebut, 
                VoteFin: VoteFin,
                EtatReu:EtatReu,
        });
        });
    }

    if (LsNews && LsNews.length > 0) {
        LsNews.slice(0, 3).forEach((news) => {
            const { DateSaisie, Objet } = news;
            liste.push({
                type: { titre: 'News', couleur: 'badge-news' },
                dDate: DateSaisie,
                objet: Objet,
                lien: {
                    pathname: '/MaCopropriete/News/Message',
                    state: { Mes: news, isNews: true },
                },
            });
        });
    }

    if (Docs) {
        const ListeDocs = Docs.filter(doc => doc.Type === 0);
        ListeDocs.slice(0, 3).forEach((doc) => {
            const { DateDeb, Objet, Id } = doc;
            /*liste.push({
                type: { titre: 'Document', couleur: 'badge-document' },
                dDate: DateDeb,
                objet: Objet,
                lien: {
                    pathname: '/MesDocuments/Document',
                    state: { Id },
                },
            });*/
        });

        const ListeCourriers = Docs.filter(doc => doc.Type === 1);
        ListeCourriers.slice(0, 3).forEach((courrier) => {
            const { DateDeb, Objet, Id } = courrier;
            liste.push({
                type: { titre: 'Courrier', couleur: 'badge-courrier' },
                dDate: DateDeb,
                objet: Objet,
                lien: {
                    pathname: '/MesDocuments/Document',
                    state: { Id },
                },
            });
        });
    }

    if (Messages) {
        const MessagesEntrants = Messages.filter(message => message.SensCom === 2 || message.SensCom === 12);
        MessagesEntrants.slice(0, 3).forEach((message) => {
            // Commentaires pour la NouvelleMessagerie
            const { DateSaisie, Objet, Memo, VuParClient, NumAuto, NumAff /*NumLigne, */ } = message;
            liste.push({
                type: { titre: 'Message', couleur: 'badge-message' },
                dDate: DateSaisie,
                objet: Objet,
                nouveau : !VuParClient,
                memo : Memo,
                lien: {
                    pathname:'/MaMessagerie/Conversation',
                    state: { NumAff } ,
                },
            });
        });
    }

    const dateTemp = new Date();
    const dateMini = dateTemp.setFullYear(dateTemp.getFullYear() - 1);
    const listeOrdre = liste.sort((l1, l2) => new Date(l2.dDate).getTime() - new Date(l1.dDate).getTime());
    const listeFiltre = listeOrdre.filter(element => new Date(element.dDate).getTime() > dateMini);
    const lsActu = listeFiltre.map((ligne, i) => <LigneActu key={i} {...ligne} />);

    return (
        <Card Titre={CardActualite.titleName}>
            {lsActu.length > 0 ? (
                <div className="list-group list-group-flush small">{lsActu}</div>
            ) : (
                <p className="card-text">
                    <i>Il n&apos;y a pas d&apos;actualités récentes à afficher.</i>
                </p>
            )}

        </Card>
    );
};
CardActualite.displayName = 'CardActualite';
CardActualite.titleName = 'Fil d’actualité';
CardActualite.requiredProps = [
    'LsReunions', // Liste des réunions
    'LsNews', // Liste des news
    'Docs', // Liste des documents
    'Messages', // Liste des documents
];

function mapStateToProps({
    CopStore: {
        Cop: { LsReunions, LsNews },
    },
    DocStore: { Docs },
    MesStore: { Messages },
    SynStore: { Syn },
}) {
    return {
        LsReunions,
        LsNews,
        Docs,
        Messages,
        Syn
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardActualite));



// WEBPACK FOOTER //
// ./src/components/Accueil/CardActualite.js